import { render, staticRenderFns } from "./paymentItem.vue?vue&type=template&id=fb17006e&functional=true&"
import script from "./paymentItem.vue?vue&type=script&lang=ts&"
export * from "./paymentItem.vue?vue&type=script&lang=ts&"
import style0 from "./paymentItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports